import { defineStore } from 'pinia';
import { datadogRum } from '@datadog/browser-rum';

export const useCookieStore = defineStore('cookie', {
  state: () => ({
    cookieConsent: {},
  }),
  actions: {
    saveConsent(preferences) {
      const ddCTrackingConsent = preferences?.performance ? 'granted' : 'not-granted';
      datadogRum?.setTrackingConsent(ddCTrackingConsent);
      this.cookieConsent = preferences;
    },
  },
});
